// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { magnifyingGlass16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-magnifying-glass': IconMagnifyingGlass;
    }
}

/**
 * The icon component for the 'magnifyingGlass' icon
 */
export class IconMagnifyingGlass extends Icon {
    public constructor() {
        super(magnifyingGlass16X16);
    }
}

registerIcon('icon-magnifying-glass', IconMagnifyingGlass);
export const iconMagnifyingGlassTag = 'nimble-icon-magnifying-glass';
